import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import WarehouseService from "../../services/WarehouseService";

export default function WarehouseListPage() {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadWarehouses();
  }, []);

  const loadWarehouses = async () => {
    setLoading(true);
    try {
      const res = await WarehouseService.getAll();
      if (res.success) {
        setWarehouses(res.data);
      }
    } catch (error) {
      console.error("Depolar yüklenirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex gap-1 justify-center">
        <Button
          icon="pi pi-search"
          tooltip="Detay"
          className="p-button-rounded p-button-text text-blue-600 dark:text-blue-400"
          onClick={() => navigate(`/warehouses/detail/${rowData.id}`)}
        />
        <Button
          icon="pi pi-pencil"
          tooltip="Düzenle"
          className="p-button-rounded p-button-text text-amber-600 dark:text-amber-400"
          onClick={() => navigate(`/warehouses/edit/${rowData.id}`)}
        />
      </div>
    );
  };

  return (
    <div className="p-2 md:p-6 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-[3rem] shadow-2xl shadow-indigo-400/20 dark:shadow-none animate-fade-in max-w-6xl mx-auto">
      <style>{`
        .dark .p-datatable {
            background: #0f172a !important;
            color: #f8fafc !important;
        }
        .dark .p-datatable-header,
        .dark .p-datatable-thead > tr > th,
        .dark .p-datatable-tbody > tr {
            background: #0f172a !important;
            color: #f8fafc !important;
            border-color: #1e293b !important;
        }
        .dark .p-datatable-tbody > tr.p-highlight {
            background: #1e293b !important;
            color: #38bdf8 !important;
        }
        .dark .p-datatable-tbody > tr:hover {
            background: #1e293b/50 !important;
        }
        .dark .p-paginator {
            background: #0f172a !important;
            color: #f8fafc !important;
            border-color: #1e293b !important;
        }
        .dark .p-paginator .p-paginator-first,
        .dark .p-paginator .p-paginator-prev,
        .dark .p-paginator .p-paginator-pages .p-paginator-page,
        .dark .p-paginator .p-paginator-next,
        .dark .p-paginator .p-paginator-last {
            color: #cbd5e1 !important;
        }
        .dark .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
            background: #1e293b !important;
            color: #38bdf8 !important;
        }
        .dark .p-datatable-loading-overlay {
            background: rgba(15, 23, 42, 0.7) !important;
        }
      `}</style>

      {/* Premium Page Header */}
      <div className="flex flex-col md:flex-row items-center justify-between mb-12 gap-6 p-6 bg-slate-900 dark:bg-slate-950 rounded-[2.5rem] text-white border border-slate-800 shadow-2xl">
        <div className="flex items-center gap-6">
          <div className="w-20 h-20 rounded-[2.5rem] bg-blue-600 flex items-center justify-center shadow-2xl border-4 border-slate-700">
            <i className="pi pi-home text-white text-3xl"></i>
          </div>
          <div>
            <h1 className="text-3xl md:text-4xl font-black text-white leading-none uppercase tracking-tighter">
              Depo Listesi
            </h1>
            <p className="text-slate-400 font-bold text-xs uppercase tracking-[0.2em] mt-3 italic">
              Tanımlı depolar ve ürün miktarları
            </p>
          </div>
        </div>
        <Button
          label="YENİ DEPO EKLE"
          icon="pi pi-plus"
          className="!bg-blue-600 hover:!bg-blue-700 border-none rounded-3xl px-6 h-[64px] font-black text-xs text-white shadow-xl transition-all hover:scale-[1.02]"
          onClick={() => navigate("/warehouses/add")}
        />
      </div>

      {/* Table Section */}
      <div className="bg-white dark:bg-slate-900 shadow-2xl shadow-slate-200/50 dark:shadow-none border border-slate-100 dark:border-slate-800 rounded-[3rem] overflow-hidden">
        <DataTable
          value={warehouses}
          loading={loading}
          className="p-datatable-sm cursor-pointer"
          responsiveLayout="scroll"
          emptyMessage="Henüz depo tanımlanmamış."
          onRowDoubleClick={(e) => navigate(`/warehouses/detail/${e.data.id}`)}
        >
          <Column field="name" header="DEPO ADI" className="p-4 font-bold text-slate-800 dark:text-slate-200" headerClassName="bg-transparent text-slate-700 dark:text-slate-300 font-black text-[14px] uppercase p-3 tracking-widest" />
          <Column field="address" header="ADRES" className="p-4 text-slate-700 dark:text-slate-300" headerClassName="bg-transparent text-slate-700 dark:text-slate-300 font-black text-[14px] uppercase p-3 tracking-widest" />
          <Column
            field="totalProductQuantity"
            header="TOPLAM ÜRÜN MİKTARI"
            body={(row) => (
              <span className="font-black text-blue-600 dark:text-blue-400">
                {row.totalProductQuantity.toLocaleString("tr-TR")}
              </span>
            )}
            style={{ width: "200px" }}
            className="p-4"
            headerClassName="bg-transparent text-slate-700 dark:text-slate-300 font-black text-[14px] uppercase p-3 tracking-widest"
          />
          <Column
            body={actionTemplate}
            style={{ width: "80px", textAlign: "center" }}
            className="p-4"
            headerClassName="bg-transparent text-slate-700 dark:text-slate-300 font-black text-[14px] uppercase p-3 tracking-widest"
          />
        </DataTable>
      </div>
    </div>
  );
}
